<template>
  <div id="Evaluation">
    <v-expansion-panels  v-if="savedSchool.letter_of_recommendation_required" focusable class="px-2 mt-3 ">
      <v-expansion-panel class="mt-2  "  >
        <v-expansion-panel-header  class="light-blue--text text--darken-4">
          <v-layout row align-center pb-0 >
            <v-icon v-if="hasRequiredLORs" color="green" >mdi-check-circle</v-icon>
            <v-icon v-else color="red" >mdi-check-circle</v-icon>
            <v-icon color="blue darken-3" class="ml-2">mdi-account-voice</v-icon>
            <span class="ml-2 blue--text text--darken-3 font-weight-medium">Evaluations</span>
          </v-layout>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">


          <!-- Required Evaluations -->
          <v-card class="innerCardCover elevation-0" style="borderRadius:5px" outlined >
            <v-layout  v-if="hasRequiredLORs" class="green pb-2 justify-center" >
              <span  class="white--text text-center mt-2">Evaluations Completed</span>
            </v-layout>
            <v-layout  v-else class="pb-2 justify-center red" >
              <span  class="white--text text-center mt-2">  {{ validCompletedEvaluations.length > totalLORSRequired ? 0 : totalLORSRequired - validCompletedEvaluations.length}} Evaluations Pending</span>
            </v-layout>


            <v-tabs
              v-model="evaluationsTab"
              background-color="transparent"
              color="basil"
              grow
              class="mt-3 px-2"
              hide-slider
              >
              <v-tab active-class="grey darken-2 white--text" style="marginLeft:0px;">
                Required Evals
              </v-tab>

              <v-tab active-class="primary white--text">
              <v-icon small class="mr-2" >mdi-account-circle</v-icon>
                My Evals
              </v-tab>
          </v-tabs>

            <v-tabs-items v-model="evaluationsTab">
              <!-- Required Evaluations Tab Item -->
              <v-tab-item class="pb-2">
                <v-layout   mt-4 mb-2 column align-center justify-center>
                    <v-progress-circular  v-if="savedSchool.letter_of_recommendation_minimum_letters_required !== '' && savedSchool.letter_of_recommendation_required" :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium " :class="{'red--text': !hasRequiredLORs, 'green--text' : hasRequiredLORs } ">{{savedSchool.letter_of_recommendation_minimum_letters_required}}</span></v-progress-circular>
                    <span v-if="savedSchool.letter_of_recommendation_minimum_letters_required === '' " class="  mb-0  body-1 font-weight-light ">No Specified Evaluations</span>
                    <span  v-if="savedSchool.letter_of_recommendation_minimum_letters_required !== ''" class="mt-1   font-weight-light">Evaluations</span>
                </v-layout>

                <!-- Specific Writers -->
                <v-card style="borderRadius:5px" outlined class="mt-4 mx-2">
                  <v-layout  v-if="savedSchool.letter_of_recommendation_specific_writers_required" class="grey lighten-3 pb-2 justify-center">
                    <span  class="red--text text-center mt-2">Specific Evaluators Required</span>
                  </v-layout>
                  <v-layout  v-if="savedSchool.letter_of_recommendation_specific_writers_preferred" class="grey lighten-3 pb-2 justify-center">
                    <span  class="amber--text amber--text text--darken-3 text-center mt-2">Specific Evaluators Preferred</span>
                  </v-layout>
                  <v-layout v-if="savedSchool.letter_of_recommendation_specific_writers_required === false && savedSchool.letter_of_recommendation_specific_writers_preferred === false"  class="grey  pb-2 justify-center">
                    <span class=" text-center mt-2 white--text">Specific Evaluators Not Required</span>
                  </v-layout>

                  <v-card-text  v-if="schoolRequiredEvaluations.length || (savedSchool.letter_of_recommendation_specific_writers_required === true || savedSchool.letter_of_recommendation_specific_writers_preferred === true)" class="pt-2  ">
                        <v-layout v-if="schoolRequiredEvaluations.length" v-for="(writer, index) in schoolRequiredEvaluations" :key="writer.id" column class="pl-0 ml-0 ">

                            <v-layout  mt-2 row   align-center justify-space-between mx-0>
                              <span class=" font-weight-light black--text ">{{writer.writer_title}}</span>
                              <v-icon v-if="!hasLORRequirement(writer, schoolRequiredEvaluations, index)" :color="getIconColor(savedSchool.letter_of_recommendation_specific_writers_required, savedSchool.letter_of_recommendation_specific_writers_preferred )" class="" size="20px">mdi-check-circle</v-icon>
                              <v-icon v-else color="green" class="" size="20px">mdi-check-circle</v-icon>
                            </v-layout>
                            <span  v-if="writer.writer_timeframe_month" class="grey--text">Minimum Time Known: <span class="font-weight-regular blue--text text--darken-3">{{writer.writer_timeframe_month}} months</span></span>
                            <span  v-if="writer.writer_timeframe_year" class="grey--text">Minimum Time Known: <span class="font-weight-regular blue--text text--darken-3">{{writer.writer_timeframe_year}} year(s)</span></span>
                            <v-divider  class="mt-2 mb-1 "></v-divider>

                        </v-layout>

                        <!-- Either One of the following Writers Needed -->
                        <v-layout column v-if="savedSchool.letter_of_recommendation_either_writers_title[0] !== 0">
                          <v-subheader class="font-weight-regular pl-0 ">
                                <v-layout v-if="savedSchool.letter_of_recommendation_specific_writers_required === true" justify-center class="red--text">ONE of the following evaluators needed</v-layout>
                          <v-layout v-if="savedSchool.letter_of_recommendation_specific_writers_preferred === true" justify-center class="amber--text text--darken-3">Either of the following evaluators preferred</v-layout>
                            </v-subheader>
                          <v-layout  v-for="(writer, index) in savedSchool.letter_of_recommendation_either_writers_title" :key="writer.id" column class="pl-0 ml-0 ">

                              <v-layout  mt-2 row   align-center justify-space-between mx-0>
                                <span class=" font-weight-light black--text ">{{writer.writer_title}}</span>
                                <v-icon v-if="!hasLORRequirement(writer, savedSchool.letter_of_recommendation_either_writers_title, index)" :color="getIconColor(savedSchool.letter_of_recommendation_specific_writers_required, savedSchool.letter_of_recommendation_specific_writers_preferred )" class="" size="20px">mdi-check-circle</v-icon>
                                <v-icon v-else color="green" class="" size="20px">mdi-check-circle</v-icon>
                              </v-layout>
                              <span  v-if="writer.writer_timeframe_month" class="grey--text">Minimum Time Known: <span class="font-weight-regular blue--text text--darken-3">{{writer.writer_timeframe_month}} months</span></span>
                              <span  v-if="writer.writer_timeframe_year" class="grey--text">Minimum Time Known: <span class="font-weight-regular blue--text text--darken-3">{{writer.writer_timeframe_year}} year(s)</span></span>
                              <v-divider  class="mt-2 mb-1 "></v-divider>

                          </v-layout>
                        </v-layout>

                  </v-card-text>



                </v-card>

              </v-tab-item>

              <!-- My Evals Tab Item-->
              <v-tab-item class="pb-2">
                <!-- Evaluations -->
                <v-layout mt-4 mb-2 column align-center justify-center>
                  <v-progress-circular :width="3" size="80" :value=100  color="grey"> <span class="percentageValue headline   blue--text text--darken-3 font-weight-medium ">{{userEvaluations.length}}</span></v-progress-circular>
                  <span class="mt-1 font-weight-light">Total Evaluations</span>
                </v-layout>
                <!-- My Evaluators Break Down -->
                <v-card style="borderRadius:5px" outlined class="mt-4 mx-2">
                  <v-layout align-center justify-center class=" primary pb-2 ">
                    <v-icon small class="mr-2 mt-2" color="white">mdi-account-circle</v-icon>
                    <span class="subtitle-1 mt-2 font-weight-regular white--text"> My Evaluators </span>
                  </v-layout>

                  <v-card-text class="pt-2  ">


                      <v-layout  v-for="writer in userEvaluations" :key="writer.id" column class="pl-0 ml-0 ">

                            <v-layout  mt-2 row   align-center mx-0>
                              <span class="primary--text ">{{writer.writer_name}}</span>
                              <span class=" font-weight-light black--text ml-1 ">{{writer.writer_title}}</span>
                            </v-layout>
                            <span  v-if="writer.writer_time_known !== '' && writer.writer_time_known !== undefined" class="grey--text">Time Known: <span class="font-weight-regular blue--text text--darken-3">{{writer.writer_time_known}} months</span></span>
                            <span class="" :class="{ 'red--text' : writer.evaluation_status === 'Not Yet Requested', 'amber--text text--darken-3' : writer.evaluation_status === 'Agreed to write evaluation', 'blue--text text--lighten-1' : writer.evaluation_status === 'Submitted to CASPA', 'green--text' : writer.evaluation_status === 'Received' }">{{writer.evaluation_status}}</span>
                            <v-divider  class="mt-2 mb-1 "></v-divider>
                        </v-layout>





                  </v-card-text>
                </v-card>


              </v-tab-item>
            </v-tabs-items>



            </v-card>

            <!-- Evaluations Notes -->
            <v-card v-if="savedSchool.evaluationsNotes" outlined class=" mt-4 mb-4">
              <v-layout align-center justify-center class=" pb-1" > 
                <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                <span class="font-weight-light align-center">Additional Notes </span>
              </v-layout>
              <v-divider></v-divider>
              <v-card-text class="text-center">
                <span>{{savedSchool.evaluationsNotes}}</span>
              </v-card-text>
            </v-card>


        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import userMixins from '@/mixins/usersmixin'
  import checkEvaluationMixin from '@/mixins/requirementchecks/checkevaluationmixin'
  export default {
    mixins: [userMixins, checkEvaluationMixin ],
    props: ['savedSchool'],
    data() {
      return {
        evaluationsTab: null,
      }
    },

  }
</script>

<style scoped>

.v-expansion-panel::before {
   box-shadow: 0 10px 20px -10px rgba(0,0,0,.19)  !important;
}
.innerCardCover {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  border-radius: 5px;
  padding: 0;
  margin-top: 12px;
}


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/RequirementTracker/Evaluation.vue